<template>
    <div>
        <div class="card-header">
            Waiting
        </div>
        <div class="card-body">
            <p>Waiting for member action...</p>
        </div>
        <div class="card-footer">
        </div>
    </div>
</template>

<script>
  import DefaultState from "./DefaultState";

  export default {
    name: "Waiting",
    extends: DefaultState,
  }
</script>

<style scoped>

</style>
